import {build} from './build';


export const mutantAbi = build.abi;
export const mutantAddress = "0xcd1B13D61574458ad4c3F4233a950146E03Ab61C"